"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRewardData = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/reward/types");
var react_1 = require("react");
var actions_1 = require("../../../../redux/reducers/draws/actions");
var action_1 = require("../../../../redux/reducers/rewards/action");
var useIsLoggedIn_1 = require("../useIsLoggedIn");
var useRewardData = function (rewardId, onError) {
    var isLoggedIn = (0, useIsLoggedIn_1.useIsLoggedIn)();
    var _a = (0, react_1.useState)(), reward = _a[0], setReward = _a[1];
    var _b = (0, react_1.useState)(), activeDraw = _b[0], setActiveDraw = _b[1];
    var _c = (0, react_1.useState)([]), drawPrizes = _c[0], setDrawPrizes = _c[1];
    var _d = (0, react_1.useState)(), entries = _d[0], setEntries = _d[1];
    var _e = (0, react_1.useState)(), coupon = _e[0], setCoupon = _e[1];
    var _f = (0, react_1.useState)(), redemption = _f[0], setRedemption = _f[1];
    var _g = (0, react_1.useState)(), promotion = _g[0], setPromotion = _g[1];
    var initData = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchFunction, rewardData, draw, prizes, drawEntries, promotionData, couponData, redemptionFrequency, redemptionFrequency;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fetchFunction = isLoggedIn ? action_1.fetchRewardWithFrequencyCapById : action_1.fetchRewardById;
                    return [4, fetchFunction(rewardId)];
                case 1:
                    rewardData = _a.sent();
                    if (!rewardData) {
                        onError();
                        return [2];
                    }
                    if (!(rewardData.type === types_1.RewardType.DRAW)) return [3, 7];
                    return [4, (0, action_1.getActiveDrawByPromotionId)(rewardData.externalId)];
                case 2:
                    draw = _a.sent();
                    if (!draw) return [3, 5];
                    return [4, (0, actions_1.fetchDrawPrizesById)(draw === null || draw === void 0 ? void 0 : draw.id)];
                case 3:
                    prizes = _a.sent();
                    return [4, (0, action_1.fetchEntries)(draw === null || draw === void 0 ? void 0 : draw.id)];
                case 4:
                    drawEntries = _a.sent();
                    setEntries(drawEntries);
                    setDrawPrizes(prizes !== null && prizes !== void 0 ? prizes : []);
                    _a.label = 5;
                case 5:
                    setActiveDraw(draw);
                    return [4, (0, action_1.getPromotionByPromotionId)(rewardData.externalId)];
                case 6:
                    promotionData = _a.sent();
                    setPromotion(promotionData);
                    _a.label = 7;
                case 7:
                    if (!(rewardData.type === types_1.RewardType.COUPON)) return [3, 9];
                    return [4, (0, action_1.fetchCoupon)(rewardData.key)];
                case 8:
                    couponData = _a.sent();
                    setCoupon(couponData);
                    _a.label = 9;
                case 9:
                    if (!(rewardData.type === types_1.RewardType.EXTERNAL)) return [3, 11];
                    return [4, (0, action_1.fetchRedemption)(rewardData.key)];
                case 10:
                    redemptionFrequency = _a.sent();
                    setRedemption(redemptionFrequency);
                    _a.label = 11;
                case 11:
                    if (!(rewardData.type === types_1.RewardType.GAMEPLAY)) return [3, 13];
                    return [4, (0, action_1.fetchRedemption)(rewardData.key)];
                case 12:
                    redemptionFrequency = _a.sent();
                    setRedemption(redemptionFrequency);
                    _a.label = 13;
                case 13:
                    setReward(rewardData);
                    return [2];
            }
        });
    }); }, [rewardId, isLoggedIn, onError]);
    (0, react_1.useEffect)(function () {
        initData();
    }, [initData]);
    return { reward: reward, activeDraw: activeDraw, drawPrizes: drawPrizes, entries: entries, coupon: coupon, promotion: promotion, redemption: redemption, setRedemption: setRedemption, setReward: setReward };
};
exports.useRewardData = useRewardData;
//# sourceMappingURL=useRewardData.js.map